<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">Events & Interventions in Nigeria</v-card-title>
          <!-- <v-divider></v-divider> -->
          <v-container class="px-4 pt-0">
            <v-layout row wrap>
              <v-flex xs12>
                <Map
                  :markers="allMarkers"
                  :aids="aidsMarkers"
                  :events="eventsMarkers"
                  v-if="!isLoading"
                />
                <v-progress-circular
                  :indeterminate="true"
                  :size="24"
                  :width="3"
                  color="grey"
                  v-if="isLoading"
                ></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import '@/plugins/google-maps'
import Map from '@/components/Map/Map.vue'
import { setFormData } from '@/utils/http'

export default {
  name: 'Maps',
  components: {
    Map
  },
  created () {
    this.isLoading = true
    this.aidsMarkers = []
    this.eventsMarkers = []
    const params = setFormData({
      country_id: this.$settings.country
    })
    this.$http.post('location/read_by_country_with_details', params)
      .then(({ data: response }) => {
        this.isLoading = false
        if (response.code === 200) {
          this.allMarkers = response.data.filter(marker => {
            return marker.events.length > 0 || marker.aids.length > 0
          })
          
          response.data.forEach(marker => {
            if (marker.aids.length > 0) this.aidsMarkers.push(marker)
            if (marker.events.length > 0) this.eventsMarkers.push(marker)
          })
        }
      })
  },
  data () {
    return {
      isLoading: false,
      allMarkers: [],
      aidsMarkers: [],
      eventsMarkers: []
    }
  }
}
</script>
